import {IRecipeCalculationFieldsFragment} from "app/gql/graphqlSchema";

interface IProps {
  calculation: IRecipeCalculationFieldsFragment;
}
export const Calculation = ({calculation}: IProps) => {
  const nutrition = calculation.nutritionPer100g;
  return (
    <div className="grid grid-cols-2 gap-2 max-w-fit text-gray-700">
      <div>Energy (kcal)</div>
      <div>{nutrition.energyKcal} kcal</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
      <div>Energy (kJ)</div>
      <div>{nutrition.energyKj} kJ</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
      <div>Fat</div>
      <div>{nutrition.fatTotal}g</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
      <div className="pl-4">Saturated</div>
      <div>{nutrition.fatSaturated}g</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
      <div>Carbs</div>
      <div>{nutrition.carb}g</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
      <div className="pl-4">Sugar</div>
      <div>{nutrition.sugar}g</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
      <div>Protein</div>
      <div>{nutrition.protein}g</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
      <div>Salt</div>
      <div>{nutrition.salt}g</div>
      <div className="col-span-2 border-b-gray-400 border-b-1" />
    </div>
  );
};
